
export default
{
  ADULT: 'ADULT',
  MEDICAL: 'MEDICAL',
  ALL: 'ALL',
};



// WEBPACK FOOTER //
// ./src/const/customer_type.js